import React from 'react';

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-[var(--surface-1)] rounded-2xl max-w-2xl w-full max-h-[80vh] flex flex-col shadow-xl animate-fade-in">
        <div className="p-6 border-b border-[var(--border-hairline)]">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-[var(--text-1)]">Terms & Conditions</h2>
            <button onClick={onClose} className="text-[var(--text-3)] hover:text-[var(--text-2)]">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        
        <div className="p-6 overflow-y-auto">
          <div className="space-y-4 text-[var(--text-2)] text-sm">
            <h3 className="font-semibold text-base">1. Introduction</h3>
            <p>Welcome to My Football Game. These Terms & Conditions govern your use of our game and services. By accessing or using My Football Game, you agree to be bound by these Terms.</p>
            
            <h3 className="font-semibold text-base">2. Account Registration</h3>
            <p>To use My Football Game, you must create an account with a valid email address. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
            
            <h3 className="font-semibold text-base">3. User Conduct</h3>
            <p>You agree not to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Use our services for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to any part of our services</li>
              <li>Interfere with the proper operation of our services</li>
              <li>Create multiple accounts or share accounts with others</li>
              <li>Use any automated means or third-party tools to access our services</li>
            </ul>
            
            <h3 className="font-semibold text-base">4. Intellectual Property</h3>
            <p>All content, features, and functionality of My Football Game, including but not limited to all information, software, text, displays, images, video, and audio, are owned by My Football Game or its licensors and are protected by international copyright, trademark, and other intellectual property laws.</p>
            
            <h3 className="font-semibold text-base">5. Gameplay and Virtual Currency</h3>
            <p>My Football Game may include virtual currency or items that can be purchased or earned through gameplay. These virtual items have no real-world value and cannot be exchanged for real money or items of value outside the game.</p>
            
            <h3 className="font-semibold text-base">6. Privacy</h3>
            <p>Our Privacy Policy describes how we collect, use, and share information about you when you use our services. By using My Football Game, you consent to the collection and use of information as detailed in our Privacy Policy.</p>
            
            <h3 className="font-semibold text-base">7. Termination</h3>
            <p>We reserve the right to terminate or suspend your account and access to My Football Game at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.</p>
            
            <h3 className="font-semibold text-base">8. Disclaimers and Limitations of Liability</h3>
            <p>My Football Game is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of My Football Game or any content accessed through our services.</p>
            
            <h3 className="font-semibold text-base">9. Changes to Terms</h3>
            <p>We may revise these Terms at any time. By continuing to use My Football Game after any changes, you accept the revised Terms.</p>
            
            <h3 className="font-semibold text-base">10. Contact Information</h3>
            <p>If you have any questions about these Terms, please contact us at olympikesoft@gmail.com.</p>
          </div>
        </div>
        
        <div className="p-6 border-t border-[var(--border-hairline)]">
          <button 
            onClick={onClose}
            className="w-full py-3 px-5 bg-[var(--accent)] text-[var(--surface-0)] text-white border-none rounded-lg text-base font-medium cursor-pointer text-center hover:brightness-110 transition-colors"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;